// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__Noxmm","headingExtra":"style_headingExtra__5soy7","email":"style_email__OZ7IR","uid":"style_uid__TzRI7","team":"style_team__3kYKg"};